export default __webpack_public_path__ + "static/media/Approved_Gray.97d738e9.svg";